import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { RateCeilingFeatureComponent } from './rate-ceiling-feature/rate-ceiling-feature.component';

const log = new LoggingService();

export const RateCeilingRoute: Ng2StateDeclaration = {
    name: 'rateceiling',
    url: '/rateceiling',
    data: { requiresAuth: true },

    component: RateCeilingFeatureComponent
};
